import { useQuery } from '@tanstack/react-query';
import apiService from '../services/api';
import { InvoiceHealthCheckResult } from '../types';
import { useAuth } from '../contexts/AuthContext';

export const useInvoiceHealthCheck = () => {
  const { user } = useAuth();
  const isSystemAdmin = typeof window !== 'undefined' && localStorage.getItem('isSystemAdmin') === 'true';
  const isSuperAdmin = isSystemAdmin || user?.roleName === 'SuperAdmin';
  
  return useQuery({
    queryKey: ['invoice-health-check'],
    queryFn: () => apiService.checkInvoiceHealth(),
    enabled: !isSuperAdmin, // Disable for superadmins
    refetchInterval: 5 * 60 * 1000, // Refetch every 5 minutes
    staleTime: 2 * 60 * 1000, // Consider stale after 2 minutes
    retry: 1, // Only retry once on failure
  });
};
